/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegalProtectionEligibilityResponse
 */
export interface LegalProtectionEligibilityResponse {
    /**
     * 
     * @type {string}
     * @memberof LegalProtectionEligibilityResponse
     */
    status: LegalProtectionEligibilityResponseStatusEnum;
    /**
     * False when the rule does not apply (natural person subscriber); status is then Eligible.
     * @type {boolean}
     * @memberof LegalProtectionEligibilityResponse
     */
    isApplicable: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegalProtectionEligibilityResponse
     */
    reasons: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof LegalProtectionEligibilityResponse
     */
    totalRevenue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LegalProtectionEligibilityResponse
     */
    totalEmployees?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LegalProtectionEligibilityResponse
     */
    subsidiariesCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LegalProtectionEligibilityResponse
     */
    revenueCeiling?: number | null;
}


/**
 * @export
 */
export const LegalProtectionEligibilityResponseStatusEnum = {
    Eligible: 'Eligible',
    ACompleter: 'ACompleter',
    NonEligible: 'NonEligible'
} as const;
export type LegalProtectionEligibilityResponseStatusEnum = typeof LegalProtectionEligibilityResponseStatusEnum[keyof typeof LegalProtectionEligibilityResponseStatusEnum];


/**
 * Check if a given object implements the LegalProtectionEligibilityResponse interface.
 */
export function instanceOfLegalProtectionEligibilityResponse(value: object): value is LegalProtectionEligibilityResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('isApplicable' in value) || value['isApplicable'] === undefined) return false;
    if (!('reasons' in value) || value['reasons'] === undefined) return false;
    return true;
}

export function LegalProtectionEligibilityResponseFromJSON(json: any): LegalProtectionEligibilityResponse {
    return LegalProtectionEligibilityResponseFromJSONTyped(json, false);
}

export function LegalProtectionEligibilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalProtectionEligibilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'isApplicable': json['isApplicable'],
        'reasons': json['reasons'],
        'totalRevenue': json['totalRevenue'] == null ? undefined : json['totalRevenue'],
        'totalEmployees': json['totalEmployees'] == null ? undefined : json['totalEmployees'],
        'subsidiariesCount': json['subsidiariesCount'] == null ? undefined : json['subsidiariesCount'],
        'revenueCeiling': json['revenueCeiling'] == null ? undefined : json['revenueCeiling'],
    };
}

export function LegalProtectionEligibilityResponseToJSON(json: any): LegalProtectionEligibilityResponse {
    return LegalProtectionEligibilityResponseToJSONTyped(json, false);
}

export function LegalProtectionEligibilityResponseToJSONTyped(value?: LegalProtectionEligibilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'isApplicable': value['isApplicable'],
        'reasons': value['reasons'],
        'totalRevenue': value['totalRevenue'],
        'totalEmployees': value['totalEmployees'],
        'subsidiariesCount': value['subsidiariesCount'],
        'revenueCeiling': value['revenueCeiling'],
    };
}

